(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fpCVg", function(module, exports) {
function $b3876204420b8191$var$close_all_modals() {
    modal_forms.style.display = "none";
    modal_about.style.display = "none";
}
function $b3876204420b8191$var$init() {
    var header_forms = document.getElementById("header_forms");
    var header_about = document.getElementById("header_about");
    var modal_forms1 = document.getElementById("modal_forms");
    var modal_about1 = document.getElementById("modal_about");
    var close_modals = document.getElementsByClassName("close_modal");
    var menu_icon = document.getElementsByClassName("menu_icon")[0];
    var details = document.getElementsByTagName("details");
    var header = document.getElementsByTagName("header")[0];
    var update_time = document.getElementById("update_time");
    menu_icon.addEventListener("click", function() {
        if (header.dataset.expanded == "true") header.dataset.expanded = "false";
        else header.dataset.expanded = "true";
    });
    for(var idx = 0; idx < close_modals.length; idx++)close_modals.item(idx).addEventListener("click", function(evt) {
        return evt.target.parentElement.parentElement.style.display = "none";
    });
    header_forms.addEventListener("click", function() {
        modal_about1.style.display = "none";
        modal_forms1.style.display = "flex";
        header.dataset.expanded = "false";
    });
    header_about.addEventListener("click", function() {
        modal_forms1.style.display = "none";
        modal_about1.style.display = "flex";
        header.dataset.expanded = "false";
    });
    document.body.addEventListener("keyup", function(evt) {
        if (evt.key == "Escape" || evt.key == "Esc") $b3876204420b8191$var$close_all_modals();
    }, true);
    window.addEventListener("beforeprint", function() {
        for(var idx = 0; idx < details.length; idx++)details.item(idx).setAttribute("open", "true");
    });
    window.addEventListener("afterprint", function() {
        for(var idx = 0; idx < details.length; idx++)details.item(idx).removeAttribute("open");
    });
    var modified_date = new Date(document.lastModified);
    update_time.innerText = modified_date.getMonth() + 1 + "/" + modified_date.getDate() + "/" + modified_date.getFullYear();
}
window.addEventListener("DOMContentLoaded", $b3876204420b8191$var$init);

});

parcelRegister("3r0rO", function(module, exports) {
function $28043d9a04b9afbb$var$analytics_ignore() {
    return localStorage.getItem("analytics-ignore") == "true" || false;
}
function $28043d9a04b9afbb$var$analytics_setup() {
    var site_loaded = sessionStorage["siteloaded"] == "true";
    var first_time = localStorage["notfirst"] != "true";
    sessionStorage["siteloaded"] = "true";
    localStorage["notfirst"] = "true";
    var mobile = undefined, browser = "Unknown", browser_version = "Unknown", system = "Unknown", language = navigator.language || "Unknown";
    if (navigator.userAgentData) {
        mobile = navigator.userAgentData.mobile;
        system = navigator.userAgentData.platform;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navigator.userAgentData.brands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var brand = _step.value;
                if (brand.brand != "Not-A.Brand" && brand.brand != "Not.A/Brand") {
                    if (browser == "Unknown") browser = "";
                    if (browser_version == "Unknown") browser_version = "";
                    browser += brand.brand + " / ";
                    browser_version += brand.version + " / ";
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (browser != "Unknown") browser = browser.substring(0, browser.length - 3);
        if (browser_version != "Unknown") browser_version = browser_version.substring(0, browser_version.length - 3);
    } else {
        if (navigator.userAgent && navigator.userAgent.toLowerCase().includes("firefox") || "netscape" in window && / rv:/.test(navigator.userAgent)) {
            browser = "Firefox";
            var match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
            if (match) browser_version = match[1];
            else {
                match = window.navigator.userAgent.match(/rv:\/([0-9]+)\./);
                if (match) browser_version = match[1];
            }
        } else if (navigator.vendor && navigator.vendor.toLowerCase().indexOf("apple") > -1 || navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("safari") > -1 && navigator.userAgent.indexOf("CriOS") == -1 && navigator.userAgent.indexOf("FxiOS") == -1) {
            browser = "Safari";
            var match1 = window.navigator.userAgent.match(/Version\/([0-9]+)\./);
            if (match1) browser_version = match1[1];
        }
        if (navigator.userAgent.toLowerCase().includes("crios")) {
            browser = "Chrome";
            system = "iOS";
            var match2 = window.navigator.userAgent.match(/CriOS\/([0-9]+)\./);
            if (match2) browser_version = match2[1];
        }
        if (navigator.userAgent.toLowerCase().includes("fxios")) {
            browser = "Firefox";
            system = "iOS";
            var match3 = window.navigator.userAgent.match(/FxiOS\/([0-9]+)\./);
            if (match3) browser_version = match3[1];
        }
    }
    if (navigator.userAgent && (system == "Unknown" || system == "")) {
        if (navigator.userAgent.toLowerCase().includes("iphone")) system = "iOS";
        else if (navigator.userAgent.toLowerCase().includes("mac")) system = "macOS";
        if (navigator.userAgent.toLowerCase().includes("windows")) system = "Windows";
        if (navigator.userAgent.toLowerCase().includes("cros")) system = "ChromeOS";
        if (navigator.userAgent.toLowerCase().includes("android")) system = "Android";
        if (navigator.userAgent.toLowerCase().includes("linux")) system = "Linux";
    }
    if (system == "iOS") mobile = true;
    if ($28043d9a04b9afbb$var$analytics_ignore()) document.getElementById("analytics_ignore").style.display = "block";
    analytics_record_event("page_load", {
        page: window.location.href,
        subpage: window.location.pathname.substring(1),
        referrer: document.referrer != "" ? document.referrer : undefined,
        page_width: window.innerWidth,
        page_height: window.innerHeight,
        // I got 2400.037623167038 for the height because the device pixel ratio was some 15-digit float... cast that to an int!
        screen_width: Math.round(Number.parseFloat(window.screen.width * window.devicePixelRatio)),
        screen_height: Math.round(Number.parseFloat(window.screen.height * window.devicePixelRatio)),
        screen_resolution: "".concat(Math.round(Number.parseFloat(window.screen.width * window.devicePixelRatio)), "x").concat(Math.round(Number.parseFloat(window.screen.height * window.devicePixelRatio))),
        mobile: mobile,
        browser: browser,
        browser_version: browser_version,
        os: system,
        language: language,
        first_visit: first_time,
        first_page_load: !site_loaded // first load this session
    });
}
//                             string, object
window.analytics_record_event = function(event) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var analytics_url = "https://script.google.com/macros/s/AKfycbzF4_BL8fYMyn1HwoCjuH4dsIO5pSenne7zOn-9XY_QqEej6oIpIkp1G84rXlTFdrYlhA/exec";
    var data_str = "".concat($28043d9a04b9afbb$var$analytics_ignore() ? "&coordinator=true" : "", "&millis_since_epoch=").concat(new Date().getTime(), "&host=").concat(window.location.host);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var datakey = _step.value;
            if (data[datakey] != undefined) data_str += "&".concat(datakey.toString().replaceAll(" ", "%20"), "=").concat(data[datakey].toString().replaceAll(" ", "%20"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var http_req = new XMLHttpRequest();
    http_req.open("GET", "".concat(analytics_url, "?event=").concat(event.toString().replaceAll(" ", "%20")).concat(data_str));
    http_req.send();
};
if (document.readyState != "loading") $28043d9a04b9afbb$var$analytics_setup();
else document.addEventListener("DOMContentLoaded", $28043d9a04b9afbb$var$analytics_setup);

});

parcelRequire("fpCVg");
parcelRequire("3r0rO");
function $b99e0137a50d8f52$var$get_volunteer_opps(callback) {
    var http_req = new XMLHttpRequest();
    http_req.onreadystatechange = function() {
        if (http_req.readyState === 4) try {
            callback(JSON.parse(http_req.response));
        } catch (err) {
            callback([]);
            console.warn("JSON parse error:");
            console.error(err);
            document.getElementById("volunteer_opportunities_sidebar").innerHTML += '<div class="center"><h4>There was a problem fetching volunteer opportunities.</h4>';
            document.getElementById("volunteer_opportunities_sidebar").innerHTML += "<h6>Please check your network connection and try again.</h6></div>";
            document.getElementsByClassName("fingerprint-spinner")[0].remove();
        }
    };
    http_req.open("GET", "https://script.google.com/macros/s/AKfycbzjWak70BnkDwcesixlFtf7Vpavxag3Ys4PGm3oyOE1ev-No-rm7dZGGsXx6DDE6tA/exec");
    http_req.send();
}
function $b99e0137a50d8f52$var$sort_by_date(list) {
    list.sort(function(first, second) {
        return new Date(first) - new Date(second);
    });
    return list;
}
function $b99e0137a50d8f52$var$get_opp_element_html(opp) {
    var WEEKDAYS = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    var datestr = "Ongoing opportunity";
    if (opp["date"] != "Ongoing") {
        if (opp["date"].toString().indexOf("=") >= 0) {
            var dates = opp["date"].split("=");
            var date1 = new Date(dates[0]);
            var date2 = new Date(dates[1]);
            datestr = "".concat(WEEKDAYS[date1.getDay()], " ").concat(date1.getMonth() + 1, "/").concat(date1.getDate(), "/").concat(date1.getFullYear(), " - ").concat(WEEKDAYS[date2.getDay()], " ").concat(date2.getMonth() + 1, "/").concat(date2.getDate(), "/").concat(date2.getFullYear());
        } else if (opp["date"].toString().indexOf(",") >= 0) {
            var dates1 = $b99e0137a50d8f52$var$sort_by_date(opp["date"].split(","));
            datestr = "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = dates1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var date = _step.value;
                    date = new Date(date);
                    if (!$b99e0137a50d8f52$var$is_date_in_past(date)) datestr += "".concat(WEEKDAYS[date.getDay()], " ").concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat(date.getFullYear(), ", ");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            datestr = datestr.substring(0, datestr.length - 2);
        } else {
            var date3 = new Date(opp["date"]);
            datestr = "".concat(WEEKDAYS[date3.getDay()], " ").concat(date3.getMonth() + 1, "/").concat(date3.getDate(), "/").concat(date3.getFullYear());
        }
    }
    var html = '<div class="sidebar_element structured_sidebar_element">\n		<p class="sse_item title">'.concat(opp["name"], '</p>\n		<!-- <p class="sse_item organization">').concat(opp["org"], '</p> -->\n		<p class="sse_item location"><a href="https://www.google.com/maps?q=').concat(opp["location"].replaceAll(" ", "+"), '" target="blank">').concat(opp["location"], '</a></p>\n		<hr>\n		<p class="sse_item daterange">').concat(datestr, "</p>");
    if (opp["link"] != "") html += '<p class="sse_item link"><a target="_blank" onclick="analytics_record_event(\'service_opportunity_clicked\', { opportunity_name: \''.concat(opp["name"], "', opportunity_url: '").concat(opp["link"], '\' });" href="').concat(opp["link"].replaceAll("javascript:", ""), '">').concat(opp["link"].replace("http://", "").replace("https://", "").replace("www.", "").replace("mailto:", "").replace("tel:", "").replaceAll("javascript:", ""), "</a></p>");
    else html += '<p class="sse_item link"><a target="_blank" onclick="analytics_record_event(\'service_opportunity_clicked\', { opportunity_name: \''.concat(opp["name"], "', opportunity_url: '").concat(opp["email"], '\' });" href="mailto:').concat(opp["email"], '">Contact ').concat(opp["email"], "</a></p>");
    // html += `<p class="sse_item email">Contact: ${opp["contact"]} (<a class="break_all" href="mailto:${opp["email"]}">${opp["email"]}</a>)</p>`
    if (opp["more_info"] != "") html += '<p class="sse_item info">Additional Info: '.concat(opp["more_info"], "</p>");
    html += "</div>";
    return html;
}
function $b99e0137a50d8f52$var$is_date_in_past(date) {
    var now = new Date();
    date.setHours(23, 59, 59);
    return date < now;
}
window.addEventListener("DOMContentLoaded", function() {
    var title_case = // TEMP: Medal list recipients
    // TODO: Consolidate this and the medal-list.html scripts
    function title_case(str) {
        var outstr = "";
        var lastchar = undefined;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _char = _step.value;
                if (!lastchar || lastchar == "-" || lastchar == " ") outstr += _char.toUpperCase();
                else outstr += _char.toLowerCase();
                lastchar = _char;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return outstr;
    };
    $b99e0137a50d8f52$var$get_volunteer_opps(function(opps) {
        opps.sort(function(first, second) {
            // If dates are ongoing they should be last
            if (first["date"] == "Ongoing" && second["date"] == "Ongoing") return 0;
            if (first["date"] == "Ongoing") return 1;
            if (second["date"] == "Ongoing") return -1;
            // Here so that when we use the date later, it isn't the changed date.
            // If we have a date range, the date range should still be present in `get_opp_element_html`
            // rather than the first date, like we set it lower.
            var first_date = first["date"];
            var second_date = second["date"];
            var first_date_object = new Date();
            var second_date_object = new Date();
            // For each date, if the start date has already passed sort by the end date, otherwise sort by the start date
            // If it doesn't have a start / end date, sort by the date given.
            function get_date_object(date_string) {
                var date_string_object = new Date();
                if (date_string.indexOf("=") > -1) {
                    var split_date_string = date_string.split("=");
                    if (!$b99e0137a50d8f52$var$is_date_in_past(new Date(split_date_string[0]))) date_string_object = new Date(split_date_string[0]);
                    else date_string_object = new Date(split_date_string[1]);
                } else if (date_string.indexOf(",") > -1) {
                    // This should get the first one not in the past, or the first one period
                    var split_date_string1 = $b99e0137a50d8f52$var$sort_by_date(date_string.split(","));
                    var date_idx = 0;
                    while($b99e0137a50d8f52$var$is_date_in_past(new Date(split_date_string1[date_idx])))date_idx++;
                    date_string_object = new Date(split_date_string1[date_idx]);
                } else date_string_object = new Date(date_string);
                return date_string_object;
            }
            first_date_object = get_date_object(first_date);
            second_date_object = get_date_object(second_date);
            return first_date_object - second_date_object;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = opps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var opp = _step.value;
                document.getElementById("volunteer_opportunities_sidebar").innerHTML += $b99e0137a50d8f52$var$get_opp_element_html(opp);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        document.getElementsByClassName("fingerprint-spinner")[0].remove();
    });
    var fetch_controller = new AbortController();
    var signal = fetch_controller.signal;
    // https://stackoverflow.com/a/12646864
    var shuffle = function(array) {
        for(var i = array.length - 1; i > 0; i--){
            var j = Math.floor(Math.random() * (i + 1));
            var ref;
            ref = [
                array[j],
                array[i]
            ], array[i] = ref[0], array[j] = ref[1], ref;
        }
    };
    fetch("resources/MedalList.25-26.txt", {
        signal: signal
    }).then(function(response) {
        return response.text();
    }).then(function(medal_list) {
        var names = medal_list.replaceAll("\r", "").replaceAll("	", " ").split("\n");
        for(var idx = 0; idx < names.length; idx++)names[idx] = title_case(names[idx]);
        var medal_list_name = document.getElementById("medal_list_name");
        var characters = "ABCDEFGHIJKLMNOPQRSTUVQXYZ";
        var get_random_string = function() {
            var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
            var str = "";
            str += characters.toUpperCase()[Number.parseInt(Math.random() * characters.length)];
            for(var idx = 1; idx < length - 2; idx++)str += characters.toLowerCase()[Number.parseInt(Math.random() * characters.length)];
            str += " ";
            str += characters.toUpperCase()[Number.parseInt(Math.random() * characters.length)];
            return str;
        };
        var interval = 50;
        var random_count = 0;
        var pause_count = 2500;
        var pause_left = 0;
        var nextname = names[Number.parseInt(Math.random() * names.length)];
        setInterval(function() {
            if (pause_left >= 0) pause_left -= interval;
            else if (random_count >= 0) {
                medal_list_name.innerText = get_random_string(nextname.length);
                random_count--;
            } else {
                medal_list_name.innerText = nextname;
                nextname = names[Number.parseInt(Math.random() * names.length)];
                pause_left = pause_count;
                random_count = 5;
            }
        }, interval);
    })["catch"](function(error) {
        console.error("Medal list error:", error);
    });
});

})();
//# sourceMappingURL=index.f64421ae.js.map
